import { ProductIdentifier } from '../../product';

export interface ContractOrProduct {
  contractId: string | null;
  productIdentifier: ProductIdentifier;
}
